import { RouteContext } from 'react-resource-router';

import { PullRequestState } from 'src/components/types/src/pull-request';
import { PullRequest } from 'src/types/pull-requests-table';

export type PRFilterState = PullRequestState | 'ALL';

export type PRFollowingType = 'REVIEWING' | 'WATCHING';

export type PRUserFilterType = PRFollowingType | 'ALL';

export enum PRListType {
  Repository = 'repository',
  Workspace = 'workspace',
}

export const isPRUserFilterType = (
  value: string
): value is PRUserFilterType => {
  return ['REVIEWING', 'WATCHING', 'ALL'].includes(value);
};

export type FilterType = {
  search: string;
  prState: PRFilterState[];
  prUserFilter: PRUserFilterType;
  authorsAaid?: string[];
  project?: string;
};

export type Query = RouteContext['query'];

export type WorkspacePullRequestsQuery = FilterType & {
  page: number;
};

export type WorkspacePullRequestsState = {
  pullRequests: PullRequest[];
  buildStatusesFetched: boolean;
};
